var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"notData",style:(_vm.boxStyle)},[_c('img',{attrs:{"src":require("@/assets/image/notData.png"),"alt":"暂无数据"}}),_c('span',[_vm._v("暂无数据")])])}
var staticRenderFns = []

export { render, staticRenderFns }